<template lang="pug">
div
    div(v-if="$store.getters.isAdmin && $store.state.queryGroupName!== 'all' && $store.state.platformPlan.isAllowSubscribeRawLogsClosing" style="display: flex;justify-content: flex-end;align-items: center")
        pre(style="margin:0 10px") {{$t('groupresource.isSubscribeRawLogs')}}
        i-switch(v-model="isSubscribeRawLogs" :before-change="handleBeforeChange" :loading="loading")
    Row(style="margin-top: 8px")
        Col(:lg="6" :md="12")
            SingleNumWrapper.singleNumCardMd(
                :chartType="'reqsumnum'"
                :chartTitle="$t('dashboard.totalRequestCount')"
                :numeralFormat="'0.00a'"
                :withCard="true"
                :textInSingleLine="false"
                maxFontSize="26px"
                style="text-align: center"
                :isGetDataFromStore="isGetDataFromStore"
                :calculateFormula="$store.getters.chartData_reqsumnum"
            )
        Col(:lg="6" :md="12")
            SingleNumWrapper.singleNumCardMd(
                :chartType="'reqUniqueIpSumNum'"
                :chartTitle="$t('dashboard.totalRequestUniqueIpCount')"
                :numeralFormat="'0.00a'"
                :withCard="true"
                :textInSingleLine="false"
                maxFontSize="26px"
                style="text-align: center"
            )
        Col(:lg="6" :md="12")
            SingleNumWrapper.singleNumCardMd(
                :chartType="'servedsumnum'"
                :chartTitle="$t('dashboard.dataServedUsage')"
                :numeralFormat="'0.00ib'"
                :withCard="true"
                :textInSingleLine="false"
                maxFontSize="26px"
                style="text-align: center"
                :isGetDataFromStore="isGetDataFromStore"
                :calculateFormula="$store.getters.chartData_servedsumnum"
            )
        Col(:lg="6" :md="12")
            SingleNumWrapper.singleNumCardMd(
                :chartType="'wafsumnum'"
                :chartTitle="$t('dashboard.wafBlockedCount')"
                :numeralFormat="'0.00a'"
                :withCard="true"
                :textInSingleLine="false"
                maxFontSize="26px"
                style="text-align: center"
                :isGetDataFromStore="isGetDataFromStore"
                :calculateFormula="$store.getters.chartData_wafsumnum"
            )
    Row
        Col(:lg="12" :md="24")
            Card.dashBoardCard
                BarChartWrapper(
                    :chartType="'servicegroupbarchart'"
                    :chartDataSetLabel="['dashboard.serviceGroupNameText']"
                    :titleDisplay="false"
                    :topNSize="3"
                    :withCard="false"
                    :direction="direction"
                    :barBorderColors="[colorScheme.blue.border]"
                    :barBackgroundColors="[colorScheme.blue.fill]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
        Col(:lg="12" :md="24")
            Card.dashBoardCard
                PieChartWrapper(
                    :chartType="'countryPieChart'"
                    :chartTitle="$t('dashboard.countryText')"
                    :topNSize="5"
                    :withCard="false"
                    :pieBackgroundColors="[colorScheme.colorSets.fill]"
                    :legendPosition="'right'"
                    :legendAlign="'start'"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
    Row
        Col(:lg="8" :md="24")
            Card.dashBoardCard
                BarChartWrapper(
                    :chartType="'domainbarchart'"
                    :chartDataSetLabel="['dashboard.domainNameText']"
                    :titleDisplay="false"
                    :topNSize="5"
                    :withCard="false"
                    :direction="direction"
                    :barBorderColors="[colorScheme.blue.border]"
                    :barBackgroundColors="[colorScheme.blue.fill]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
        Col(:lg="8" :md="24")
            Card.dashBoardCard
                BarChartWrapper(
                    :chartType="'domainBarChartByDataUsage'"
                    :numeralFormat="'0.00ib'"
                    :chartDataSetLabel="['dashboard.dataServedUsage']"
                    :titleDisplay="false"
                    :topNSize="5"
                    :withCard="false"
                    :direction="direction"
                    :barBorderColors="[colorScheme.blue.border]"
                    :barBackgroundColors="[colorScheme.blue.fill]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
        Col(:lg="8" :md="24")
            Card.dashBoardCard
                BarChartWrapper(
                    :chartType="'domainPeakBandwidthMbps'"
                    :chartTitle="'dashboard.domainNameText'"
                    :chartDataSetLabel="['dashboard.peakBandwidthMbpsText', 'dashboard.totalTrafficGBText']"
                    :titleDisplay="false"
                    :topNSize="5"
                    :withCard="false"
                    :direction="direction"
                    :datasetUnitLabels="['Mbps', 'GiB']"
                    :barBorderColors="[colorScheme.blue.border, colorScheme.grey.border]"
                    :barBackgroundColors="[colorScheme.blue.fill, colorScheme.grey.fillTransparent]"
                    :hiddenDatasetIndices="[1]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    :switchDatasetWithLegend="true"
                )
    Row
        Col(:lg="24" :md="24")
            Card.dashBoardCard
                LineChartWrapper(
                    :chartType="'reqlinechart'"
                    :chartDataSetLabel="['dashboard.totalRequestCount']"
                    :titleDisplay="false"
                    :withCard="false"
                    :numeralFormat="'0.00a'"
                    :linePointRadius="[4]"
                    :linePointHoverRadius="[8]"
                    :linePointBackgroundColor="['white']"
                    :linePointBorderWidth="[3]"
                    :lineBorderColors="[colorScheme.blue.border]"
                    :linePointHoverBorderWidth="[5]"
                    :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                    :linePointHoverBackgroundColor="['white']"
                    :lineBackgroundGradientStops="[colorScheme.blue.gradientStops]"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    :isSetDataToStore="isSetDataToStore"
                )
                SingleNumWrapper(
                    :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                    :chartType="'reqsumnum'"
                    :chartTitle="$t('dashboard.totalRequestCount')"
                    :numeralFormat="'0.00a'"
                    :withCard="false"
                    :textInSingleLine="true"
                    :maxFontSize="'16px'"
                    style="text-align: right"

                )
                SingleNumWrapper(
                    :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
                    :chartType="'reqRateNum'"
                    :chartTitle="$t('dashboard.avgRequestSpeedRate')"
                    :numStringSuffix="' / s'"
                    :withCard="false"
                    :textInSingleLine="true"
                    :maxFontSize="'16px'"
                    style="text-align: right"
                )
    Row
        Col(:lg="16" :md="24")
            CacheLineChartSet
        Col(:lg="8" :md="12")
            Card.dashBoardCard
                PieChartWrapper(
                    :chartType="'cacheStatusPieChart'"
                    :chartTitle="$t('dashboard.cacheRatioText')"
                    :numeralFormat="'0.00ib'"
                    :topNSize="5"
                    :withCard="false"
                    :pieBackgroundColors="[colorScheme.colorSets.fill]"
                    :legendPosition="'right'"
                    :legendAlign="'start'"
                    :isGetDataFromStore="isGetDataFromStore"
                    :calculateFormula="$store.getters.chartData_cacheStatusPieChart"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"

                )
                SingleNumWrapper(
                    :class="showRawBtnStyle == 'iconBtn' ? 'underPieChartWrapper' : ''"
                    :chartType="'cacheRatioNum'"
                    :chartTitle="$t('dashboard.cacheRatioText')"
                    :numeralFormat="'0%'"
                    :withCard="false"
                    :textInSingleLine="true"
                    :maxFontSize="'16px'"
                    style="text-align: right"
                    :isGetDataFromStore="isGetDataFromStore"
                    :calculateFormula="$store.getters.chartData_cacheRatio"
                )
    Row
        Col(:lg="16" :md="24")
            Card.dashBoardCard
                LineChartWrapper(
                    :chartType="'edgewaftypelinechart'"
                    :chartTitle="$t('dashboard.wafBlockTypeTitleText')"
                    :withCard="false"
                    :linePointRadius="[4]"
                    :linePointHoverRadius="[8]"
                    :linePointBackgroundColor="['white']"
                    :linePointBorderWidth="[3]"
                    :lineBorderColors="colorScheme.colorSets.border"
                    :useBackendDatasetLabel="true"
                    :legendPosition="'right'"
                    :legendAlign="'start'"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                    :isSetDataToStore="isSetDataToStore"

                )
        Col(:lg="8" :md="12")
            Card.dashBoardCard
                PieChartWrapper(
                    :chartType="'waftypepiechart'"
                    :chartTitle="$t('dashboard.wafEventTitleText')"
                    :topNSize="5"
                    :withCard="false"
                    :pieBackgroundColors="[colorScheme.colorSets.fill]"
                    :legendPosition="'right'"
                    :legendAlign="'start'"
                    :isGetDataFromStore="isGetDataFromStore"
                    :calculateFormula="$store.getters.chartData_waftypepiechart"
                    :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                )
</template>
<script>
import bus from "@/libs/bus.js";

import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";
import CacheLineChartSet from "@/components/dashboard/CacheLineChartSet";

import { getEsData, _updateData } from "@/api/esdata.js";

import colorScheme from "@/data/colorScheme";

export default {
    name: "RequestSummary",
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper,
        CacheLineChartSet,
    },
    data() {
        return {
            loading: true,
            isSubscribeRawLogs: true,
            colorScheme: colorScheme,
            chartHeight: 340,
            direction: "horizontal",
            isGetDataFromStore: true,
            isSetDataToStore: true,
            groupResourceData: {},
            assetCategory: "groupResources",
            esIndex: "rcm-edgegroup",
            searchOptions: {
                isFuzzySearch: true,
                esIndex: "rcm-edgegroup",
                from: 0,
                size: 10,
                sort: [
                    {
                        modifiedDate: {
                            order: "desc",
                        },
                    },
                ],
                filters: [
                    {
                        key: "groupName",
                        type: "string",
                        value: this.$store.state.queryGroupName,
                    },
                ],
                searchView: "GroupResource",
            },
        };
    },
    methods: {
        async getGroupResourceData() {
            await getEsData(this.searchOptions)
                .then((res) => {
                    this.loading = false;
                    this.groupResourceData = res.data.mapData[0];
                    this.isSubscribeRawLogs = this.groupResourceData.isSubscribeRawLogs;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async updateGroupSubscribeRawLogsStatus() {
            let groupResourceData = Object.assign(this.groupResourceData, {});
            groupResourceData.isSubscribeRawLogs = !this.isSubscribeRawLogs;
            await _updateData(this.esIndex, "index", groupResourceData)
                .then((result) => {
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `${result.data.message}`,
                    });
                    this.getGroupResourceData();
                })
                .catch((error) => {
                    let errorObject = Object.assign({}, error);
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${error}`,
                    });
                });
        },
        handleBeforeChange() {
            return new Promise((resolve) => {
                this.$Modal.confirm({
                    title: this.$i18n.t("rcmtable.changeStatusText"),
                    content: this.$i18n.t("rcmtable.confirmChangeStatusText"),
                    okText: this.$i18n.t("rcmtable.confirmText"),
                    cancelText: this.$i18n.t("rcmtable.cancelText"),
                    onOk: async () => {
                        this.loading = true;
                        await this.updateGroupSubscribeRawLogsStatus();
                        resolve();
                    },
                });
            });
        },
    },
    async mounted() {
        if (
            this.$store.getters.isAdmin &&
            this.$store.state.queryGroupName !== "all" &&
            this.$store.state.platformPlan.isAllowSubscribeRawLogsClosing
        ) {
            await this.getGroupResourceData();
        }
    },
    computed: {
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
    },
};
</script>

<style scoped>
.singleNumCardMd {
    text-align: center;
    height: auto;
    margin: 6px 6px 0px 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/dashboard/RequestSummary.vue